import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import DBModal from "../../../../component/global/DBModal";
import DBTable from "../../../../component/global/DBTable/DBTable";
import TakingOrderTotalAmount from "./TakingOrderTotalAmount";
import DBButton from "../../../../component/global/DBButton";
import {ReactComponent as Person} from "../../../../asset/icons/personIcon.svg";
import {ReactComponent as Phone} from "../../../../asset/icons/smartIcon.svg";
import {ReactComponent as Status} from "../../../../asset/icons/statusIcon.svg";
import {ReactComponent as Box} from "../../../../asset/icons/boxIcon.svg";

function TakingOrderModal(props) {
  const {show, onHide, data, onClickBtn, loading} = props
  const {t} = useTranslation()

  const headers = useMemo(() => {
    return [
      {
        id: 'title',
        title: t('Organizational.Restaurant.TakingOrder.DetailModal.Table.Title'),
        gridTemplateColumns: 'auto'
      },
      {
        id: 'count',
        title: t('Organizational.Restaurant.TakingOrder.DetailModal.Table.Count'),
        gridTemplateColumns: '80px'
      },
      {
        id: 'unitAmount',
        title: t('Organizational.Restaurant.TakingOrder.DetailModal.Table.UnitAmount'),
        gridTemplateColumns: '120px',
        numberWithComma: true,
      },
      {
        id: 'totalAmount',
        title: t('Organizational.Restaurant.TakingOrder.DetailModal.Table.TotalAmount'),
        gridTemplateColumns: '120px',
        // rowStyle: {textAlign: 'center'},
        numberWithComma: true,
      },
    ]
  }, [t])

  const rows = useMemo(() => {
    let tmp = []
    if (data?.orderItems?.length) {
      tmp = data.orderItems?.map(item => {
        return {
          title: item?.item_name,
          count: item?.quantity,
          unitAmount: item?.price,
          totalAmount: item?.price && item?.quantity ? item.price * item.quantity : 0,
        }
      })
    }

    return tmp
  }, [data])

  return (
    <DBModal
      minWidth={300}
      show={show}
      onHide={onHide}
      className="takingOrder-modal"
    >
      <DBModal.Content>
        <div className='header-modal'>
          <div className='takingOrder-modal-header-item'>
            <Person/>
            <span>{t('Organizational.Restaurant.TakingOrder.DetailModal.Name.Label')}: {data?.customer}</span>
          </div>
          <div className='takingOrder-modal-header-item'>
            <Box/>
            <span>{t('Organizational.Restaurant.TakingOrder.DetailModal.CodeOrder.Label')}: {data?.code}</span>
          </div>
          <div className='takingOrder-modal-header-item'>
            <Phone/>
            <span>{t('Organizational.Restaurant.TakingOrder.DetailModal.PhoneNumber.Label')}: {data?.phoneNumber}</span>
          </div>
          <div className='takingOrder-modal-header-item'>
            <Status/>
            <span>{t('Organizational.Restaurant.TakingOrder.DetailModal.Status.Label')}: {data?.status}</span>
          </div>
        </div>
        <div className='content-modal'>
          <DBTable minWidth={500} headers={headers} rows={rows}/>
          <TakingOrderTotalAmount price={data?.price}/>
          <div className='takingOrder-btn-modal'>
            <DBButton
              loading={loading}
              caption={t('Organizational.Restaurant.TakingOrder.DetailModal.Btn')}
              onClick={onClickBtn}
            />
          </div>
        </div>
      </DBModal.Content>
    </DBModal>
  );
}

export default TakingOrderModal;
